import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Oralia',
    quote: 'Por primera vez sentí que podía comer rico sin estar peleada con la comida. Las recetas son fáciles y no me hacen sentir que estoy castigándome.'
  }, {
    name: 'Juan Luis',
    quote: 'Lo que más me gustó fue la parte de restaurantes y salidas. Yo necesitaba algo realista, no una dieta imposible. Este método se adapta a mi vida.'
  }, {
    name: 'Ana Lucía',
    quote: 'Me ayudó muchísimo a dejar la mentalidad de todo o nada. Ahora tengo opciones simples para comer mejor incluso cuando tengo ansiedad o poco tiempo.'
  }];
  return <section className="py-24 bg-white" data-id="element-188">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <FadeIn data-id="element-190">
          <div className="text-center mb-16" data-id="element-191">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm-brown mb-4" data-id="element-192">
              Esto es lo que ya están diciendo
            </h2>
            <p className="text-lg text-gray-600" data-id="element-193">
              Personas como Oralia, Juan Luis y Ana Lucía ya están usando este
              método
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-194">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-195">
              <div className="bg-cream rounded-2xl p-8 shadow-sm border border-warm-beige relative h-full flex flex-col" data-id="element-196">
                <Quote className="text-warm-brown/20 absolute top-6 right-6" size={48} data-id="element-197" />
                <div className="flex-grow relative z-10" data-id="element-198">
                  <p className="text-gray-700 text-lg italic leading-relaxed mb-8" data-id="element-199">
                    "{testimonial.quote}"
                  </p>
                </div>
                <div className="mt-auto pt-6 border-t border-warm-brown/10" data-id="element-200">
                  <p className="font-serif font-bold text-xl text-olive-green" data-id="element-201">
                    {testimonial.name}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}